__turbopack_context__.v({
  "author": "PortalReviews-module__bcrb_a__author",
  "avatar": "PortalReviews-module__bcrb_a__avatar",
  "container": "PortalReviews-module__bcrb_a__container",
  "editButton": "PortalReviews-module__bcrb_a__editButton",
  "empty": "PortalReviews-module__bcrb_a__empty",
  "emptyIcon": "PortalReviews-module__bcrb_a__emptyIcon",
  "list": "PortalReviews-module__bcrb_a__list",
  "listMeta": "PortalReviews-module__bcrb_a__listMeta",
  "loadError": "PortalReviews-module__bcrb_a__loadError",
  "loading": "PortalReviews-module__bcrb_a__loading",
  "loadingDot": "PortalReviews-module__bcrb_a__loadingDot",
  "loadingOverlay": "PortalReviews-module__bcrb_a__loadingOverlay",
  "pageButtons": "PortalReviews-module__bcrb_a__pageButtons",
  "pagination": "PortalReviews-module__bcrb_a__pagination",
  "reply": "PortalReviews-module__bcrb_a__reply",
  "results": "PortalReviews-module__bcrb_a__results",
  "resultsContent": "PortalReviews-module__bcrb_a__resultsContent",
  "review": "PortalReviews-module__bcrb_a__review",
  "reviewActions": "PortalReviews-module__bcrb_a__reviewActions",
  "reviewBody": "PortalReviews-module__bcrb_a__reviewBody",
  "reviewHeader": "PortalReviews-module__bcrb_a__reviewHeader",
  "reviewMeta": "PortalReviews-module__bcrb_a__reviewMeta",
  "reviewStack": "PortalReviews-module__bcrb_a__reviewStack",
  "reviewsEnter": "PortalReviews-module__bcrb_a__reviewsEnter",
  "reviewsPulse": "PortalReviews-module__bcrb_a__reviewsPulse",
  "status": "PortalReviews-module__bcrb_a__status",
  "success": "PortalReviews-module__bcrb_a__success",
  "viewSwitcher": "PortalReviews-module__bcrb_a__viewSwitcher",
  "visuallyHidden": "PortalReviews-module__bcrb_a__visuallyHidden",
});
